<div *ngIf="error" class="error-container">
  <mat-icon>warning</mat-icon>
  <p class="error">
    {{error}}
  </p>
</div>
<div *ngIf="error" class="button-container">
  <button mat-button color="secondary" (click)="continue()">
    <mat-icon>refresh</mat-icon>
    {{'INTL_CONTINUE' | translate}}
  </button>
</div>

<table *ngIf="nodes?.length" mat-table [dataSource]="nodes">
  <ng-container matColumnDef="name">
    <th mat-header-cell *matHeaderCellDef> {{'INTL_NAME' | translate}} </th>
    <td mat-cell *matCellDef="let element">
      <div class="file-name-container">
        <div class="file-name">
          <fa-icon
            [icon]="getIcon(element?.type)"
            class="icon small"
            [ngClass]="getIconColor(element?.type)"
          ></fa-icon>
          <strong>{{ element.name }}</strong>
        </div>
        <div *ngIf="element.error" class="form-error">{{element.error}}</div>
      </div>
    </td>
  </ng-container>

  <ng-container matColumnDef="size">
    <th mat-header-cell *matHeaderCellDef> {{'INTL_SIZE' | translate}} </th>
    <td mat-cell *matCellDef="let element">
      {{ element.size | fileSize }}
    </td>
  </ng-container>

  <ng-container matColumnDef="actions">
    <th mat-header-cell *matHeaderCellDef></th>
    <td mat-cell *matCellDef="let index = index; let element" style="text-align:right;">
      <div *ngIf="element.isDownloading" class="icon-container">
        <mat-spinner class="file-spinner" diameter="21"></mat-spinner>
      </div>
      <div *ngIf="element.isDownloaded" class="icon-container">
        <mat-icon color="primary">check_circle</mat-icon>
      </div>
    </td>
  </ng-container>

  <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
  <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
  <tr class="mat-row" *matNoDataRow>
    <td class="mat-cell" colspan="3">
      {{'INTL_EMPTY_FILES_LIST' | translate}}
    </td>
  </tr>
</table>
